/* eslint-disable camelcase */
import type { Settings, Limits } from './types';

/**
 * @deprecated use getSettings from '@hotjar/settings' instead
 */
export function get(): Settings | null {
  return window.settings;
}

export type { Settings, Limits };

export { fetchSettings } from './api';
